import { useMemo } from "react"
import { useForm } from "react-hook-form"

import { useAssignRef } from "shared/lib/useAssignRef"

import { MultiEditProductPositionFormProps } from "../MultiEditProductPositionForm"

export function useMultiEditProductPositionFormViewModel({
  defaultFormData,
  formRef,
  onSubmit,
  ...rest
}: MultiEditProductPositionFormProps) {
  const form = useForm({ defaultValues: defaultFormData })

  useAssignRef({ ref: formRef, value: form })

  const handleSubmit = useMemo(
    () => form.handleSubmit(onSubmit),
    [form.handleSubmit, onSubmit]
  )

  return {
    ...rest,
    form,
    onSubmit: handleSubmit
  }
}
